window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('./navigation');
require('./auth');

import {Application} from "@hotwired/stimulus";
import LazyLoad from 'vanilla-lazyload';
import BlockAsyncController from "./controllers/block-async-controller";
import ApplicationController from "./controllers/application-controller";
import AxiosFormController from "./controllers/axios-form-controller";
import CheckboxToggleController from "./controllers/checkbox-toggle-controller";
import CookieBarController from "./controllers/cookie-bar-controller";
import DatePickerController from "./controllers/date-picker-controller";
import ModalController from "./controllers/modal-controller";
import TabController from "./controllers/tab-controller";
import SliderController from "./controllers/slider-controller";
import ExpandableController from "./controllers/expandable-controller";
import LeafletController from "./controllers/leaflet-maps-controller";
import MembershipFiltersController from "./controllers/membership-filters-controller";
import CheckoutDebitController from './controllers/checkout-debit-controller';
import UserInfoEditController from "./controllers/user-info-edit-controller";
import PaymentController from "./controllers/payment-controller";
import SchedulesController from "./controllers/schedules-controller";
import FaqController from "./controllers/faq-controller";
import HeaderController from "./controllers/header-controller";
import ProfileMessagesController from "./controllers/profile-messages-controller";
import WebappController from "./controllers/webapp-controller";
import StickyFooterController from "./controllers/sticky-footer-controller";
import 'fslightbox';

var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});

window.Stimulus = Application.start();

Stimulus.register("block-async", BlockAsyncController);
Stimulus.register("application", ApplicationController);
Stimulus.register("axios-form", AxiosFormController);
Stimulus.register("checkbox-toggle", CheckboxToggleController);
Stimulus.register("cookie-bar", CookieBarController);
Stimulus.register("date-picker", DatePickerController);
Stimulus.register("modal", ModalController);
Stimulus.register("tab", TabController);
Stimulus.register("slider", SliderController);
Stimulus.register("expandable", ExpandableController);
Stimulus.register("leaflet", LeafletController);
Stimulus.register("membership-filters", MembershipFiltersController);
Stimulus.register("checkout-debit", CheckoutDebitController);
Stimulus.register("user-info-edit", UserInfoEditController);
Stimulus.register("payment-controller", PaymentController);
Stimulus.register('schedules', SchedulesController);
Stimulus.register('faq', FaqController);
Stimulus.register('header', HeaderController);
Stimulus.register('profile-messages', ProfileMessagesController);
Stimulus.register('webapp', WebappController);
Stimulus.register('sticky-footer', StickyFooterController);
